import 'slick-carousel';

/**
 * Handle Slider
 */
const handleSlider = (slider = '.js-slider') => {
	const $slider = $(slider);

	$slider.each(function() {
		const $this = $(this);
		let slides = $this.data('slides');
		let slidesTablet = $this.data('slides-tablet');
		let infiniteSetting = $this.data('infinite');
		let $arrowLeft = $this.find('.js-arrow-left');
		let $arrowRight = $this.find('.js-arrow-right');
		const $slider = $this.find('.js-slider-slides')

		if (slides === undefined) {
			slides = 1;
		}

		if (slidesTablet === undefined) {
			slidesTablet = slides;
		}

		if (infiniteSetting === undefined) {
			infiniteSetting = true;
		}

		if ($arrowLeft === undefined) {
			$arrowLeft = $('<button type="button" class="slick-prev">Previous</button>');
		}

		if ($arrowRight === undefined) {
			$arrowRight = $('<button type="button" class="slick-next">Next</button>');
		}

		$slider.on('init', function(slick) {
			const $compareNav = $('.section-compare__nav');

			if ($compareNav.length > 0) {
				$compareNav.find('li').eq($slider.find('.slick-slide.slick-current').index()).addClass('is-current');
			}
		});

		$slider.slick({
			slidesToShow: slides,
			slidesToScroll: 1,
			infinite: infiniteSetting,
			dots: true,
			arrows: true,
			prevArrow: $arrowLeft,
			nextArrow: $arrowRight,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: slidesTablet,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

		$slider.on('afterChange', function(event, slick, currentSlide) {
			const $compareNav = $('.section-compare__nav');

			if ($compareNav.length > 0) {
				$compareNav.find('li').eq(currentSlide).addClass('is-current').siblings().removeClass('is-current');
			}
		});
	});
}

handleSlider();

/**
 * Listen for changes done in the Theme Editor
 */
$(document).on('shopify:section:load', function(event) {
	const $currentSection = $('[id*="' + event.detail.sectionId + '"]');

	if ($currentSection.hasClass('section-testimonials')) {
		$currentSection.find('.js-slider').each(function(index, el) {
			const $this = $(this);

			if ($this.find('.js-slider-slides').hasClass('slick-initialized')) {
				return;
			}

			handleSlider($this);
		});
	}
});
